import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  text_1: {
    required,
  },
};

export default validations;
